<template>
  <loading v-if="loading" />
  <error-messages
    v-else-if="!loading && errorMessagesGetList.length > 0"
    :messages="errorMessagesGetList"
  />
  <empty-list
    v-else-if="
      !loading && errorMessagesGetList.length === 0 && items.length === 0
    "
    :srcImage="require('@/assets/images/domain-empty.png')"
    btnText=""
  >
    <template v-slot:messages>
      <p>
        <strong>هیج دامنه‌ای تاکنون ثبت نشده است.</strong>
      </p>
    </template>
  </empty-list>
  <main-page-service v-else title="لیست دامنه‌های اضافه شده" btnText="">
    <b-table
      responsive
      hover
      :items="items"
      :fields="fields"
      table-class="table-list-table"
      thead-tr-class="table-list-thead-tr"
      tbody-tr-class="table-list-tbody-tr"
    >
      <template #cell(type)="data">
        <span v-if="data.item.type === 1">
          CPU
        </span>
        <span v-if="data.item.type === 2">
          RAM
        </span>
        <span v-if="data.item.type === 3">
          Storage
        </span>
      </template>
      <template #cell(operation)="data">
        <b-button
          size="sm"
          variant="outline-info"
          class="table-list-operation"
          @click="showUpdateModal(data.item.id)"
        >
          <b-icon icon="eye-fill"></b-icon>
        </b-button>
      </template>
    </b-table>
    <resource-update-modal
      :resourceId="resourceId"
      :visible="visibleUpdateModal"
      @hidden="hiddenUpdateModal"
      @updatedSuccess="getResourcesList"
    />
  </main-page-service>
</template>

<script>
import MainPageService from "@/components/MainPageService/MainPageService";
import { resourcesListAdmin } from "@/services/resource";
import Loading from "@/components/Loading/Loading.vue";
import EmptyList from "@/components/EmptyList/EmptyList.vue";
import ErrorMessages from "@/components/ErrorMessages/ErrorMessages.vue";
import ResourceUpdateModal from "./ResourceUpdateModal.vue";

export default {
  name: "AppList",
  components: {
    MainPageService,
    Loading,
    EmptyList,
    ResourceUpdateModal,
    ErrorMessages
  },
  data() {
    return {
      loading: false,
      fields: [
        {
          key: "type",
          label: "نوع منبع",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "minValue",
          label: "کمترین مقدار",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "maxValue",
          label: "بیشترین مقدار",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "growthRate",
          label: "واحد افزایشی",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "pricePerUnit",
          label: "قیمت هر واحد",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "operation",
          label: "عملیات",
          thClass: "text-center",
          tdClass: "text-center"
        }
      ],
      items: [],
      errorMessagesGetList: [],
      // update modal data
      resourceId: null,
      visibleUpdateModal: false
    };
  },
  mounted() {
    this.getResourcesList();
  },
  methods: {
    getResourcesList: async function() {
      this.loading = true;
      const [error, data] = await resourcesListAdmin();
      if (error) {
        this.loading = false;
        this.errorMessagesGetList = error;
      } else {
        if (data.apiStatus === 200) {
          this.loading = false;
          data.apiData.map(item => {
            item["operation"] = "";
          });
          this.items = data.apiData;
        } else {
          this.loading = false;
          this.errorMessagesGetList = data.apiErrors;
        }
      }
    },
    // update modal method
    showUpdateModal: function(id) {
      this.resourceId = id;
      this.visibleUpdateModal = true;
    },
    hiddenUpdateModal: function() {
      this.visibleUpdateModal = false;
    }
  }
};
</script>
